import { render, staticRenderFns } from "./Authed.vue?vue&type=template&id=37ac2d09"
import script from "./Authed.vue?vue&type=script&lang=js"
export * from "./Authed.vue?vue&type=script&lang=js"
import style0 from "./Authed.vue?vue&type=style&index=0&id=37ac2d09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports